import React from 'react';

const defaultValue = {};

export const DependentDataContext = React.createContext(defaultValue);

/**
 * Just a context that you can throw whatever data you want into, so
 * that they can be used in conjuction with deeped data entry components
 * i.e. an Auction creation that requires Garage creation inside the same page
 */
const DependentDataProvider = ({ children }) => {
  const [data, setData] = React.useState({});

  const contextValue = React.useMemo(
    () => ({
      clear: () => setData(defaultValue),
      data,
      setData,
    }),
    [data, setData]
  );

  return (
    <DependentDataContext.Provider value={contextValue}>
      {children}
    </DependentDataContext.Provider>
  );
};

export default DependentDataProvider;
